<template>
	<span>
		<span
						class=""
						style="cursor: pointer;"
						@click="showPriceCalcModal = true"
				>
				{{ calcAndFormatPrice(liveListing.sellingPriceMin, liveListing.currencySymbol, 1, liveListing.marketaccount.ownShippingFee) }}
		</span>

		<!-- Modal with simulated table -->
		<b-modal
				:id="'price-calc-log-modal-' + liveListing.listingId"
				v-model="showPriceCalcModal"
				hide-footer
				hide-header
				size="small"
				@hide="showPriceCalcModal = false"
		>
			<div class="price-calc-grid">
				<template v-for="(g, gIndex) in liveListing?.priceCalcLog" :key="gIndex">
					<div><strong>{{ g[0] }}</strong></div>
					<div>{{ g[1] }}</div>
				</template>
			</div>
		</b-modal>
	</span>
</template>

<script>
export default {
  props : {
    liveListing: {
      type : Object,
      required: true,
    }
  },
  data() {
		return {
			showPriceCalcModal: false
		}
	},
	methods: {
		calcAndFormatPrice(price, currencySymbol, conversionRate = 1, ownShippingFee = 0) {
			if(ownShippingFee == null) ownShippingFee = 0;

			return Number((Number(price) + Number(ownShippingFee)) * Number(conversionRate)).toFixed(2) + ' ' + currencySymbol;
		},
	}
}
</script>
<style scoped>
.price-calc-grid {
	display: grid;
	grid-template-columns: 150px 1fr; /* Two columns: key + value */
	gap: 4px;
	font-size: 0.85rem;
}

.price-calc-grid .header {
	font-weight: bold;
	background: #f0f0f0;
	padding: 4px;
	border-bottom: 1px solid #ccc;
}

.price-calc-grid > div {
	padding: 4px;
	border-bottom: 1px solid #eee;
	overflow-wrap: anywhere;
}
</style>